import { render, staticRenderFns } from "./packInfoConfig.vue?vue&type=template&id=2050b8b5&scoped=true"
import script from "./packInfoConfig.vue?vue&type=script&lang=js"
export * from "./packInfoConfig.vue?vue&type=script&lang=js"
import style0 from "./packInfoConfig.vue?vue&type=style&index=0&id=2050b8b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2050b8b5",
  null
  
)

export default component.exports